module.exports = __webpack_public_path__ + "static/media/download-badge.32d03587.png";